module.exports = __webpack_public_path__ + "img/Sibiu_Mocanita_kl.7b7b51a8.jpg";